import { render, staticRenderFns } from "./AdvertisementCard.vue?vue&type=template&id=57ee15ef&"
import script from "./AdvertisementCard.vue?vue&type=script&lang=js&"
export * from "./AdvertisementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports